import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

import { adminTablesModule } from './adminTables/index';
import { mainModule } from './main';
import { State } from './state';
import { adminModule } from './admin';
import { landingModule } from './landingPage';
import { employeesModule } from './employees';
import { menuModule } from './menu';
import { adminDevicesModule } from './adminDevices';
import { inventoryModule } from './inventory';
import { userDashboardModule } from './userDashboard';

Vue.use(Vuex);

const storeOptions: StoreOptions<State> = {
  modules: {
    main: mainModule,
    admin: adminModule,
    landingPage: landingModule,
    employees: employeesModule,
    menu: menuModule,
    adminTables: adminTablesModule,
    adminDevices: adminDevicesModule,
    inventory: inventoryModule,
    userDashboard: userDashboardModule
  },
};

export const store = new Vuex.Store<State>(storeOptions);

export default store;
